export const pfrTextTerms = {
  standardUsers: {
    pluralCapitalized: 'Standard users',
    pluralPascalCase: 'Standard Users',
    pluralLowerCase: 'standard users',
    pluralUpperCase: 'STANDARD USERS',
    singularCapitalized: 'Standard user',
    singularPascalCase: 'Standard User',
    singularLowerCase: 'standard user',
    singularUpperCase: 'STANDARD USER',
  },
  approve: {
    pluralCapitalized: 'Approve',
    pluralLowerCase: 'approve',
    pluralUpperCase: 'APPROVE',
    singularCapitalized: 'Approve',
    singularLowerCase: 'approve',
    singularUpperCase: 'APPROVE',
  },
  disapprove: {
    pluralCapitalized: 'Disapprove',
    pluralLowerCase: 'disapprove',
    pluralUpperCase: 'DISAPPROVE',
    singularCapitalized: 'Disapprove',
    singularLowerCase: 'disapprove',
    singularUpperCase: 'DISAPPROVE',
  },
} as const;
